/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesAuthCreateTempTokenResponse interface.
 */
export function instanceOfFxIdWebFeaturesAuthCreateTempTokenResponse(value) {
    if (!('TempToken' in value) || value['TempToken'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesAuthCreateTempTokenResponseFromJSON(json) {
    return FxIdWebFeaturesAuthCreateTempTokenResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthCreateTempTokenResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'TempToken': json['TempToken'],
    };
}
export function FxIdWebFeaturesAuthCreateTempTokenResponseToJSON(json) {
    return FxIdWebFeaturesAuthCreateTempTokenResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthCreateTempTokenResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'TempToken': value['TempToken'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesAuthCreateTempTokenResponse.js.map